import { formatInTimeZone, fromZonedTime, toZonedTime } from "date-fns-tz";

export const getLocalizedTime = (utcDateString, timeZone = "Asia/Amman") => {
  const rawUTC = new Date(utcDateString);
  return toZonedTime(rawUTC, timeZone);
};

export const getLocalizedTimeForRegion = (
  utcTimeOnlyString,
  timeZone = "Asia/Amman"
) => {
  const rawUTC = new Date(utcTimeOnlyString);
  const now = new Date();

  const adjustedUTC = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      rawUTC.getUTCHours(),
      rawUTC.getUTCMinutes(),
      rawUTC.getUTCSeconds()
    )
  );

  return toZonedTime(adjustedUTC, timeZone);
};

export const getUTCDate = (
  dateString,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
) => {
  const [year, month, day] = dateString.split("-").map(Number);
  const localDate = new Date(year, month - 1, day, 0, 0, 0);
  return fromZonedTime(localDate, timeZone);
};

export const getFormattedTimeInZone = (
  utcTimeOnlyString,
  timeZone = "Asia/Amman"
) => {
  const rawUTC = new Date(utcTimeOnlyString);
  const now = new Date();

  const adjustedUTC = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      rawUTC.getUTCHours(),
      rawUTC.getUTCMinutes(),
      rawUTC.getUTCSeconds()
    )
  );

  return formatInTimeZone(adjustedUTC, timeZone, "HH:mm");
};

export const convertTimeStringToUTCWithToday = (timeString, timeZone) => {
  const [hours, minutes] = timeString.split(":").map(Number);

  const now = new Date();
  const localTime = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    hours,
    minutes,
    0
  );

  const utcDate = fromZonedTime(localTime, timeZone);
  return utcDate;
};

export const getUTCDateWithPeakTimeFromDate = (
  importeDate,
  peakTime = "17:00",
  timeZone = "Asia/Amman"
) => {
  const date = new Date(importeDate);

  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error("Invalid Date input");
  }

  const [hours, minutes] = peakTime.split(":").map(Number);

  const dateWithTime = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    hours,
    minutes,
    0
  );

  const utcDate = fromZonedTime(dateWithTime, timeZone);
  return utcDate.toISOString();
};
